import React, { useState, useEffect } from "react";
import "./Blogs.css";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowRight,
	faClock,
	faUser,
	faTimes,
	faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase-config";

function Blogs() {
	const [posts, setPosts] = useState([]);
	// eslint-disable-next-line
	const [loading, setLoading] = useState(true);
	const [selectedPost, setSelectedPost] = useState(null);
	const [searchTerm, setSearchTerm] = useState("");
	const [filteredPosts, setFilteredPosts] = useState([]);

	useEffect(() => {
		const fetchPosts = async () => {
			try {
				const postsQuery = query(
					collection(db, "blogPosts"),
					orderBy("createdAt", "desc")
				);
				const querySnapshot = await getDocs(postsQuery);
				const fetchedPosts = querySnapshot.docs.map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));
				setPosts(fetchedPosts);
				setFilteredPosts(fetchedPosts);
			} catch (error) {
				console.error("Error fetching posts:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchPosts();
	}, []);

	useEffect(() => {
		const results = posts.filter((post) =>
			Object.values(post).some((value) =>
				value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
			)
		);
		setFilteredPosts(results);
	}, [searchTerm, posts]);

	const openModal = (post) => {
		setSelectedPost(post);
		document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
	};

	const closeModal = () => {
		setSelectedPost(null);
		document.body.style.overflow = "unset"; // Re-enable scrolling
	};

	return (
		<div className="main-container">
			<div className="blog-search-container">
				<div className="blog-search-wrapper">
					<FontAwesomeIcon icon={faSearch} className="search-icon" />
					<input
						type="text"
						placeholder="Search blogs..."
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className="blog-search-input"
					/>
				</div>
				{searchTerm && (
					<p className="search-results-count">
						Found {filteredPosts.length}{" "}
						{filteredPosts.length === 1 ? "result" : "results"}
					</p>
				)}
			</div>

			<div className="blog-grid">
				{filteredPosts.map((post) => (
					<article key={post.id} className="blog-card">
						<div className="blog-card-image">
							<img src={post.imageUrl} alt={post.title} />
						</div>
						<div className="blog-card-content">
							<h2>{post.title}</h2>
							<p>{post.excerpt}</p>
							<div className="blog-card-meta">
								<span>
									<FontAwesomeIcon icon={faUser} /> {post.author}
								</span>
								<span>
									<FontAwesomeIcon icon={faClock} /> {post.readTime}
								</span>
							</div>
							<button
								className="read-more-button"
								onClick={() => openModal(post)}
							>
								Read More
								<FontAwesomeIcon icon={faArrowRight} />
							</button>
						</div>
					</article>
				))}
				{filteredPosts.length === 0 && !loading && (
					<div className="no-results">
						<p>No blog posts found matching your search.</p>
					</div>
				)}
			</div>

			{/* Blog Post Modal */}
			{selectedPost && (
				<div className="blog-modal-overlay" onClick={closeModal}>
					<div
						className="blog-modal-content"
						onClick={(e) => e.stopPropagation()}
					>
						<button className="blog-modal-close" onClick={closeModal}>
							<FontAwesomeIcon icon={faTimes} />
						</button>
						<div className="blog-modal-image">
							<img src={selectedPost.imageUrl} alt={selectedPost.title} />
						</div>
						<div className="blog-modal-body">
							<h2>{selectedPost.title}</h2>
							<div className="blog-modal-meta">
								<span>
									<FontAwesomeIcon icon={faUser} /> {selectedPost.author}
								</span>
								<span>
									<FontAwesomeIcon icon={faClock} /> {selectedPost.readTime}
								</span>
							</div>
							<div className="blog-modal-text">{selectedPost.content}</div>
						</div>
					</div>
				</div>
			)}

			<Footer />
		</div>
	);
}

export default Blogs;
